import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import Testimonials from "../components/Testimonials";

function TestimonialsPage() {
  return (
    <>
      <section className="testimonial-page">
        <HeroPages name="Testimonials" />
        <Testimonials />
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a Ride by getting in touch with us</h2>
              <span>
                <i className="fa-solid fa-phone" style={{color:'#f7931e'}}></i>
                <h4 style={{fontFamily:'Montserrat',color:'#f7931e'}}>(234) 810 619 2990</h4>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default TestimonialsPage;
